import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from 'styled-media-query';
import { ifProp } from 'styled-tools';
import { Icon } from 'components/shared';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  small: PropTypes.bool,
  status: PropTypes.oneOf(['success', 'warning', 'money', 'successHouse']),
  title: PropTypes.string,
  text: PropTypes.string,
};

const defaultProps = {
  children: undefined,
  className: null,
  small: false,
  status: 'success',
  title: undefined,
  text: undefined,
};

const statusIcons = {
  success: 'successIcon',
  warning: 'warningIcon',
  successHouse: 'successHouseIcon',
  money: 'moneyHouseIcon',
};

function Congratulation({ className, children, status, small, title, text }) {

  return (
    <StyledCongratulation className={className}>
      <IconWrapper>
        <Icon icon={statusIcons[status]} width="6.25" withoutFill={status === 'money'} />
      </IconWrapper>
      <ContentWrapp small={small}>
        {title && <Title small={small}>{title}</Title>}
        {text && <Text>{text}</Text>}
        {children}
      </ContentWrapp>
    </StyledCongratulation>
  );
}

const StyledCongratulation = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const IconWrapper = styled.div`
  color: var(--color-primary);
`;

const ContentWrapp = styled.div`
  text-align: left;
  padding-left: ${ifProp('small', '0.625rem', '1.9375rem')};
  ${media.lessThan('large')`
    flex-basis: ${ifProp('small', null, '50%')};
  `};
`;

const StyledImage = styled.img`
  display: block;
  width: ${ifProp('small', '3.75rem', '6.25rem')};
  height: ${ifProp('small', '3.75rem', '6.25rem')};
  min-width: ${ifProp('small', '3.75rem', '6.25rem')};
`;

const Title = styled.div`
  margin-bottom: ${ifProp('small', '0.0625rem', '0.9375rem')};
  font-weight: 300;
  font-size: var(--font-size-l);
  color: var(--color-primary);
  letter-spacing: 0.03125rem;
`;

const Text = styled.div`
  font-weight: 300;
  font-size: var(--font-size-s);
  color: var(--color-primary);
  letter-spacing: 0;
  line-height: 1.8125rem;
`;

Congratulation.propTypes = propTypes;
Congratulation.defaultProps = defaultProps;
export default Congratulation;
